// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Azure SDK namespace.
 * @internal
 */
export const AzNamespace = "az.namespace";
/**
 * Azure SDK Eventhub.
 * @internal
 */
export const MicrosoftEventHub = "Microsoft.EventHub";
/**
 * Azure SDK message bus destination.
 * @internal
 */
export const MessageBusDestination = "message_bus.destination";
